"use client";

import dynamic from "next/dynamic";
import { Heading } from "../design-system/atoms/Heading";
import type { BlockProps } from "./blocks/registry";

import { Paragraph } from "../design-system/atoms/Paragraph";

const MapComponent = dynamic(() => import("./MapComponent"), {
  ssr: false,
});

type MapSectionData = {
  id?: number | string;
  documentId?: string;
  __component?: string;
  title: string;
  descr?: string;
  [key: string]: unknown;
};

export default function MapSection({ data }: BlockProps<MapSectionData>) {
  return (
    <section className="my-10 " key={data.documentId}>
      <div className="lms-container">
        {/* Titre */}
        <Heading as="h2" className="text-4xl lg:text-[44px] font-bold text-text text-center">
          {data.title.split(" ").map((word: string, i: number) =>
            i === 1 ? (
              <span key={i} className="text-secondary">
                {word}{" "}
              </span>
            ) : (
              word + " "
            )
          )}
        </Heading>
        <Paragraph className="text-center pb-5">{data.descr}</Paragraph>
      </div>

      <MapComponent />
    </section>
  );
}